export const convertDate = (date) => {
  const dateToConvert = new Date(date);
  let day = dateToConvert.getDate();
  let month = dateToConvert.getMonth() + 1;
  const year = dateToConvert.getFullYear();

  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }

  return day + "/" + month + "/" + year;
};

export const convertBrazilianDateToISO = (date) => {
  const dateToConvert = new Date(date);
  let day = dateToConvert.getDate();
  let month = dateToConvert.getMonth() + 1;
  const year = dateToConvert.getFullYear();

  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }

  return year + "-" + month + "-" + day;
};

export const dateIsValid = (date) => {
  let isValid =
    Object.prototype.toString.call(date) === "[object Date]" && isFinite(date);

  return isValid;
};

export const convertBrazilianStringDatoToIso = (date) => {
  var b = date.split(/\D/);
  return b.reverse().join('-');
};
